import { handleActions } from 'redux-actions';

import {
  successLogin,
  tokenUpdate,
  deviceTokenUpdate,
  reset,
  setFailedLoginAttemptsNumber,
  setError,
  notifyUserNotSupported,
  successAskResetPassword,
  resetAskForgotPasswordPage,
  successResetPassword,
  resetForgotPasswordPage,
} from '@app/actions/userActions';

const initialState = {
  isLoggedIn: false,
  isNotSupportedModalVisible: false,
  authToken: null,
  deviceAuthToken: null,
  failedLoginAttemptsNumber: 0,
  error: null,
  isAskResetComplete: false,
  isResetComplete: false,
};

export default handleActions({
  [successLogin]: state => ({
    ...state,
    isLoggedIn: true,
    failedLoginAttemptsNumber: 0,
    error: null,
  }),
  [tokenUpdate]: (state, { payload }) => ({
    ...state,
    authToken: payload,
  }),
  [deviceTokenUpdate]: (state, { payload }) => ({
    ...state,
    deviceAuthToken: payload,
  }),
  [reset]: () => ({
    ...initialState,
  }),
  [setFailedLoginAttemptsNumber]: (state, { payload }) => ({
    ...state,
    failedLoginAttemptsNumber: payload,
  }),
  [setError]: (state, { payload }) => ({
    ...state,
    error: payload,
  }),
  [notifyUserNotSupported]: (state, { payload = false }) => ({
    ...state,
    isNotSupportedModalVisible: payload,
  }),
  [successAskResetPassword]: state => ({
    ...state,
    isAskResetComplete: true,
  }),
  [resetAskForgotPasswordPage]: state => ({
    ...state,
    isAskResetComplete: false,
  }),
  [successResetPassword]: state => ({
    ...state,
    isResetComplete: true,
  }),
  [resetForgotPasswordPage]: state => ({
    ...state,
    isResetComplete: false,
  }),
}, initialState);
